import { createFileRoute, redirect } from "@tanstack/react-router"
import { DEFAULT_POST_AUTH_DEST, hasAuthCookie } from "~/lib/authConfig"

// Bare `/auth` is a 404 in TanStack's flat routing — none of `auth.signin`,
// `auth.verify`, `auth.callback` claim the index. Treat it as a smart redirect:
// authenticated → wherever they should land; otherwise → signin.
export const Route = createFileRoute("/auth/")({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router uses non-Error throw for control flow
    throw redirect({
      to: hasAuthCookie() ? DEFAULT_POST_AUTH_DEST : "/auth/signin",
      replace: true,
    })
  },
})
